export function translationsFilter(filterEnabled = true) {
  return `translations(filter: { languages_code: { code: { ${filterEnabled ? '_eq: $locale' : '_nnull: true'} } } })`
}
